'use client';
import { createProps, createSplitProps } from '@chakra-ui/utils';

const tooltipProps = createProps()([
  "arrowPadding",
  "arrowShadowColor",
  "arrowSize",
  "closeDelay",
  "closeOnClick",
  "closeOnEsc",
  "closeOnPointerDown",
  "closeOnScroll",
  "defaultIsOpen",
  "direction",
  "gutter",
  "id",
  "isDisabled",
  "isOpen",
  "modifiers",
  "offset",
  "onClose",
  "onOpen",
  "openDelay",
  "placement"
]);
const splitTooltipProps = createSplitProps(tooltipProps);

export { splitTooltipProps, tooltipProps };
